  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
//import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
//import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
//import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CardsService }                                 from "../../_services";
//import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  //------
  // Style
  //------
  import TransferOnlineCardsStyle                            from "./TransferOnlineCardsStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import Card_List_Icon                                      from "assets/img/wu/Card_List_Icon.svg";
  import checkBox_checked                                    from "assets/img/wu/checkBox_checked.svg";
  import checkBox_unchecked                                  from "assets/img/wu/checkBox_unchecked.svg";
  //----------
  // variables
  //----------
  const filename = "TransferOnlineCards ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

class TransferOnlineCards extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      checkBox_newCard                                     : false,

      viewPleaseWait_hidden                                : true,

      parserObject_cards                                   : [],
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    this.get_cardType_FromObj                                         = this.get_cardType_FromObj.bind(this);
    this.get_cardNumMasked_FromObj                                    = this.get_cardNumMasked_FromObj.bind(this);
    this.get_expDatetime_FromObj                                      = this.get_expDatetime_FromObj.bind(this);

    this.btn_next_act                                                 = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                      = this.btn_next_act_isDisabled.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="TransferOnline3"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //localStorage.setItem("accessToken", "bad717b8-e102-408f-97b0-9f8aefed26d2");
    //let shouldForceRefreshAccessToken = wu_Utilities.shouldForceRefreshAccessToken();
    //if(api.print_logs){console.log('cookie='+Cookies.get('testCookie'));}

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_cardslistdetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(api.print_logs){console.log("retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
    if(retrieveWSData_getCurrencies){
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
      });
    }
    else{
      try{
        let res = JSON.parse(localStorage.getItem("currencies"));
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      }catch(err){
        console.log('err='+err);
      }
    }


    let parserObject_cards_res = [];
    try{ parserObject_cards_res = JSON.parse(localStorage.getItem("parserObject_cards_res"));}catch(err){console.log(methName+'err='+err);parserObject_cards_res = [];}
    if(parserObject_cards_res.length > 0){
      this.setState({ "parserObject_cards": parserObject_cards_res });
    }
    else{
      this.setState({ "parserObject_cards": [] });
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------
        //wu_cards_cardslist
        //------------------
        wu_CardsService
        .wu_cards_cardslist({})
        .then(res => {
          localStorage.setItem("parserObject_cards_res",JSON.stringify(res.custCardTokenList));
          this.setState({ "parserObject_cards": res.custCardTokenList });
          this.stopSpinners();
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      }.bind(this), 500);
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  {/* <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button> */}
                </div>
              </GridItem>
              {/* <GridItem xs={10} sm={10} md={11}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("TransferOnlineCards_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem> */}
            </GridContainer>

            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop: 10, marginBottom: 70  }}>
                  <div className={classes.label1}>{this.NSInforString("TransferOnlineCards_lbl_lb1")}</div>
                </div>
                <div style={{ marginTop: 10, marginBottom: 0  }}>
                  <div className={classes.label2}>{this.NSInforString("TransferOnlineCards_lbl_lb2")}</div>
                </div>
              </GridItem>
            </GridContainer>

            {localStorage.getItem("mobileOpen")==="true" ? (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.parserObject_cards.map(e => (
                    <React.Fragment key={"fragmentId_"+e.token}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_card(e)}>
                        <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                          <GridItem xs={2} sm={2} md={2}>
                            <GridContainer justify="center" style={{paddingTop:30, paddingLeft:10}}>
                              <div className={classes.Card_List_Icon_mobile}><img src={Card_List_Icon} alt="Card_List_Icon_mobile" /></div>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={8} sm={8} md={8}>
                            <GridContainer justify="center" style={{paddingTop:25, paddingLeft:0}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={2} sm={2} md={2}>
                            <GridContainer justify="center" style={{paddingTop:40, paddingRight:0}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={e.preSelected===true? checkBox_checked : checkBox_unchecked} alt="checkBox_Icon_mobile" /></div></GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                    </React.Fragment>
                  ))}
                  <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_newCard({})}>
                    <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                      <GridItem xs={2} sm={2} md={2}>
                        <GridContainer justify="center" style={{paddingTop:30, paddingLeft:10}}>
                          <div className={classes.Card_List_Icon_mobile}><img src={Card_List_Icon} alt="Card_List_Icon_mobile" /></div>
                        </GridContainer>
                      </GridItem>
                      <GridItem xs={8} sm={8} md={8}>
                        <GridContainer justify="center" style={{paddingTop:25, paddingLeft:5}}>
                          {this.state.checkBox_newCard===true ? (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard_checked}>{this.NSInforString("TransferOnlineCards_lbl_newCard")}</div></GridItem>
                          ) : (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard}>{this.NSInforString("TransferOnlineCards_lbl_newCard")}</div></GridItem>
                          )}
                        </GridContainer>
                      </GridItem>
                      <GridItem xs={2} sm={2} md={2}>
                        <GridContainer justify="center" style={{paddingTop:40, paddingRight:0}}>
                          {this.state.checkBox_newCard===true ? (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={checkBox_checked} alt="checkBox_Icon_mobile" /></div></GridItem>
                          ) : (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_mobile}><img src={checkBox_unchecked} alt="checkBox_Icon_mobile" /></div></GridItem>
                          )}
                        </GridContainer>
                      </GridItem>
                    </GridContainer>
                  </ListItem>
                </List>
              </div>
            ) : (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.parserObject_cards.map(e => (
                    <React.Fragment key={"fragmentId_"+e.token}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_card(e)}>
                        <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                          <GridItem xs={3} sm={3} md={3}>
                            <GridContainer justify="center" style={{paddingTop:18, paddingLeft:10}}>
                              <div className={classes.Card_List_Icon_desktop}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={7} sm={7} md={7}>
                            <GridContainer justify="center" style={{paddingTop:25, paddingLeft:0}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={2} sm={2} md={2}>
                            <GridContainer justify="center" style={{paddingTop:38, paddingRight:0}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={e.preSelected===true? checkBox_checked : checkBox_unchecked} alt="checkBox_Icon_desktop" /></div></GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                    </React.Fragment>
                  ))}
                  <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_newCard({})}>
                    <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:0, paddingRight:0}}>
                      <GridItem xs={3} sm={3} md={3}>
                        <GridContainer justify="center" style={{paddingTop:18, paddingLeft:10}}>
                          <div className={classes.Card_List_Icon_desktop}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                        </GridContainer>
                      </GridItem>
                      <GridItem xs={7} sm={7} md={7}>
                        <GridContainer justify="center" style={{paddingTop:35, paddingLeft:0}}>
                          {this.state.checkBox_newCard===true ? (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard_checked}>{this.NSInforString("TransferOnlineCards_lbl_newCard")}</div></GridItem>
                          ) : (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_newCard}>{this.NSInforString("TransferOnlineCards_lbl_newCard")}</div></GridItem>
                          )}
                        </GridContainer>
                      </GridItem>
                      <GridItem xs={2} sm={2} md={2}>
                        <GridContainer justify="center" style={{paddingTop:38, paddingRight:0}}>
                          {this.state.checkBox_newCard===true ? (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={checkBox_checked} alt="checkBox_Icon_desktop" /></div></GridItem>
                          ) : (
                            <GridItem xs={12} sm={12} md={12}><div className={classes.checkBox_Icon_desktop}><img src={checkBox_unchecked} alt="checkBox_Icon_desktop" /></div></GridItem>
                          )}
                        </GridContainer>
                      </GridItem>
                    </GridContainer>
                  </ListItem>
                </List>
              </div>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_next_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_next_act}
                    type="submit">
                    {this.NSInforString("TransferOnlineCards_btn_continue")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("TransferOnlineCards_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  onListItemClick_card(obj){
    let methName = filename+"onListItemClick_card ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //-------------
    //expired check
    //-------------
    for(var jj=0; jj<this.state.parserObject_cards.length; ++jj){
      if(this.state.parserObject_cards[jj].token===obj.token && this.state.parserObject_cards[jj].expired===true){
        this.dialog_handleOpen(this.NSInforString("TransferOnlineCards_msg_cardExpired"));
        return;
      }
    }

    var parserObject_cards_TMP = JSON.parse(JSON.stringify(this.state.parserObject_cards));
    for(var i=0; i<parserObject_cards_TMP.length; ++i){
      parserObject_cards_TMP[i].preSelected = false;
    }
    for(var j=0; j<parserObject_cards_TMP.length; ++j){
      if(parserObject_cards_TMP[j].token===obj.token){
        parserObject_cards_TMP[j].preSelected = true;
      }
    }

    this.setState({"parserObject_cards":parserObject_cards_TMP, "checkBox_newCard":false});

    localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
    localStorage.setItem("parserObject_selectedTokenizedCard", JSON.stringify(obj));
  }
  //----------------------------------------------------------------------------------------------------
  onListItemClick_newCard(obj){
    let methName = filename+"onListItemClick_newCard ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    var parserObject_cards_TMP = JSON.parse(JSON.stringify(this.state.parserObject_cards));
    for(var i=0; i<parserObject_cards_TMP.length; ++i){
      parserObject_cards_TMP[i].preSelected = false;
    }
    //for(var j=0; j<parserObject_cards_TMP.length; ++j){
    //  if(parserObject_cards_TMP[j].token===obj.token){
    //    parserObject_cards_TMP[j].preSelected = true;
    //  }
    //}

    this.setState({"parserObject_cards":parserObject_cards_TMP, "checkBox_newCard":true});

    localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
    localStorage.setItem("parserObject_selectedTokenizedCard", {});
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_cardType_FromObj(obj){
    if(obj){
      return obj.cardType;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_cardNumMasked_FromObj(obj){
    if(obj){
      return obj.cardNumMasked;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_expDatetime_FromObj(obj){
    if(obj){
      return obj.expDatetime.replace('-', '/');
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;

      var foundSelection = false;
      for(var i=0; i<this.state.parserObject_cards.length; ++i){
        if(this.state.parserObject_cards[i].preSelected === true){
          var obj = this.state.parserObject_cards[i];
          localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
          localStorage.setItem("parserObject_selectedTokenizedCard", JSON.stringify(obj));
          foundSelection = true;
        }
      }
      if(foundSelection===false && this.state.checkBox_newCard===true){
        localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
        localStorage.setItem("parserObject_selectedTokenizedCard", {});
        foundSelection = true;
      }
      if(foundSelection===false){emptyFields=true;}

      if(emptyFields===true){/*this.stopLockers();*/return;}
    }

    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("TransferOnline3"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {

    if(localStorage.getItem("prev_view").trim()==="TransferOnline3"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("TransferOnline2"));
    }
    else{
      //history.go(-1);
      history.goBack();
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IE11----------------------------------------------
  //----------------------------------------------------------------------------------------------------
  // IE11_not_loading_state_workaround(){
  //   let ua   = window.navigator.userAgent;
  //   let msie = ua.indexOf("MSIE ");
  //   if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)){
  //     let stateObj = {};
  //     let hasAField = false;
  //     //if(this.state.textField1===""){ stateObj.textField1 = Cookies.get('rcv_fname'); hasAField = true; }
  //     //if(this.state.textField2===""){ stateObj.textField2 = Cookies.get('rcv_lname'); hasAField = true; }
  //     if(hasAField===true){this.setState(stateObj);}
  //   }
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnlineCards.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnlineCardsStyle)(TransferOnlineCards)
);
